module.exports = __webpack_public_path__ + "static/media/ios-body.6308adf4.svg";